import { PropsInterface } from "../../../../FilesPage/FilesPage";
import { getQueryIntParam } from "../../../../../../services/WedApi/Utils/QueryParameter";
import { parse } from "query-string";
import { IFolder } from "../../../../../../services/WedApi/Models/File";
import container from "../../../../../../container";
import FetchDataReturnInterface from "./FetchDataReturnInterface";
import DataFilesInterface from "../DataFilesInterface";
import OpenFileParamsInterface from "./ParamsInterface/OpenFileParamsInterface";
import { FileTypeEnum } from "../../../../Type/FileTypeEnum";
import { generatePath } from "react-router-dom";
import RoutesEnum from "../../../../../../services/Routes/RoutesEnum";
import { BreadcrumbItem } from "../../../../../breadcrumbs/Breadcrumbs";
import { SizeType, WedIcon } from "../../../../../wed-icon/WedIcon";
import { WedIconHomeMenuMore } from "../../../../../wed-icon/generated/WedIconSvg";
import React from "react";
import BreadcrumbsParamsInterface from "./ParamsInterface/BreadcrumbsParamsInterface";
import OpenSectionParamsInterface from "./ParamsInterface/OpenSectionParamsInterface";
import { LogicError } from "../../../../../../errors/error-app";

export default class MyLibraryFilesData implements DataFilesInterface {
    async fetch(props: PropsInterface): Promise<FetchDataReturnInterface> {
        const dirId = props.overrideDirId || getQueryIntParam(parse(props.location.search), "dir");
        return this.getFolder(dirId as number, props.userId as number);
    }

    async getFolder(dirId: number, userId: number): Promise<FetchDataReturnInterface> {
        const folder: IFolder = await container.filesService.getFolder(FileTypeEnum.MY_LIBRARY_FILES, dirId, { userId });
        const directories = folder.directories;

        return {
            isLoading: false,
            directories: directories,
            parentFolder: folder.directory,
            files: folder.files,
            collection: undefined,
            dir: {
                id: folder.directory.id,
                folder: folder,
            },
        };
    }

    didUpdate(prevProps: PropsInterface, currentProps: PropsInterface): boolean {
        if (prevProps.location.search !== currentProps.location.search) {
            const prevDir = getQueryIntParam(parse(prevProps.location.search), "dir");
            const dirId = getQueryIntParam(parse(currentProps.location.search), "dir");
            if ((!prevDir && dirId) || (prevDir && prevDir !== dirId)) {
                return true;
            }
        }

        return false;
    }

    openFile(params: OpenFileParamsInterface): string {
        return `${generatePath(RoutesEnum.MY_LIBRARY_MEDIA_GALLERY_DETAILS, {
            objectId: params.objectId,
        })}?dir=${params.dirId}`;
    }

    breadcrumbs(breadcrumbsParams: BreadcrumbsParamsInterface): BreadcrumbItem[] {
        if (!breadcrumbsParams.dir) {
            throw new LogicError(`dir is required for type: ${FileTypeEnum.MY_LIBRARY_FILES}`);
        }

        const folder = breadcrumbsParams.dir.folder;
        const paths = folder.directory.paths;
        return paths.map((path, i) => {
            return {
                id: path.id,
                title: i === 0 ? undefined : path.name,
                children: i === 0 ? <WedIcon size={SizeType.SMALL} icon={<WedIconHomeMenuMore />} /> : undefined,
                link: i === 0 ? `/my-library/files` : `/my-library/files?dir=${path.id}`,
                subItems:
                    paths[i + 1] && paths[i + 1].nexts?.length > 0
                        ? paths[i + 1].nexts
                              .filter((subItem) => !paths.find((path) => path.id === subItem.id))
                              .map((subItem) => {
                                  return {
                                      id: subItem.id,
                                      label: subItem.name,
                                      link: generatePath(RoutesEnum.MY_LIBRARY_FILES) + `?dir=${subItem.id}`,
                                  };
                              })
                        : folder.directories.map((directory) => {
                              return {
                                  id: directory.id,
                                  label: directory.name,
                                  link: generatePath(RoutesEnum.MY_LIBRARY_FILES) + `?dir=${directory.id}`,
                              };
                          }),
            };
        });
    }

    openFolder(directoryId: number): string {
        return `${generatePath(RoutesEnum.MY_LIBRARY_FILES)}?dir=${directoryId}`;
    }

    openSection(params: OpenSectionParamsInterface): string {
        return `${generatePath(RoutesEnum.MY_LIBRARY_FILES)}${params.dirId ? `?dir=${params.dirId}` : ""}`;
    }

    getRootDirName(): string {
        return "My Library";
    }

    showTrash(): boolean {
        return true;
    }
}
